// extracted by mini-css-extract-plugin
export var body = "upload-module--body--9VMyA";